import getAddressCoordinates from '$lib/modules/explore/get-address-coordinates';
import filters from '../store';


/**
 * @param {Event} e
 * @param {string} value
 */
export default async function addDestination(e, value) {
	e.preventDefault();

	const coords = await getAddressCoordinates(value);
	const [lon, lat] = coords.message.Geometry.Point;

	filters.update((/** @type {any} */ store) => ({ ...store, lat, lon, destination: value.split(',')[0] }));
}
